module.exports = __webpack_public_path__ + "static/frame.f0230b2a.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/tower/frame.png
// module id = 249
// module chunks = 0